// const impactCarouselElement = document.querySelector('#impactCarousel')

// const carousel = new bootstrap.Carousel(impactCarouselElement, {
//   interval: 2000,
//   touch: true
// });
const spotlightCarouselElement = document.querySelector('#spotlightCarousel')

const spotlightCarousel = new bootstrap.Carousel(spotlightCarouselElement, {
  interval: 2000,
  touch: true
})